export { default } from './useInvestments'
